import { css } from "@emotion/react";
import React from "react";
import { Theme, useTheme } from "../theme";

export interface ContainerProps {
  maxWidth?: keyof Theme["breakpoints"];
  children?: React.ReactNode;
}
export const Container = ({ maxWidth, children }: ContainerProps) => {
  const { breakpoints, spacing } = useTheme();
  return (
    <div
      css={[
        css`
          box-sizing: border-box;
          display: block;
          width: 100%;
          padding-right: ${spacing * 2}px;
          padding-left: ${spacing * 2}px;
          margin-right: auto;
          margin-left: auto;
        `,
        maxWidth &&
          css`
            @media (min-width: ${breakpoints[maxWidth]}px) {
              max-width: ${breakpoints[maxWidth]}px;
            }
            @media (min-width: ${breakpoints[maxWidth]}px) {
              padding-right: ${spacing * 3}px;
              padding-left: ${spacing * 3}px;
            }
          `,
      ]}
    >
      {children}
    </div>
  );
};
